import { useMemo, useState } from 'react';
import type { Site } from '../types';

// Typeahead site picker.
export default function SiteSelector({
  sites,
  value,
  onChange,
}: {
  sites: Site[];
  value: string | null;
  onChange: (siteId: string | null) => void;
}) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);

  const selected = sites.find((s) => s.site_id === value) ?? null;
  const label = (s: Site) => s.name || s.address || s.site_id;

  const matches = useMemo(() => {
    const needle = q.trim().toLowerCase();
    if (!needle) return sites.slice(0, 20);
    return sites
      .filter((s) =>
        [s.name, s.address, s.city, s.site_id].some((f) => f?.toLowerCase().includes(needle))
      )
      .slice(0, 20);
  }, [q, sites]);

  return (
    <div style={{ position: 'relative' }}>
      <input
        className="input"
        placeholder="Search a site / address…"
        value={open ? q : selected ? label(selected) : q}
        onFocus={() => {
          setOpen(true);
          setQ('');
        }}
        onChange={(e) => {
          setQ(e.target.value);
          setOpen(true);
        }}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
      />
      {open && matches.length > 0 && (
        <div
          className="card"
          style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 20, maxHeight: 260, overflow: 'auto', marginTop: 4 }}
        >
          {matches.map((s) => (
            <div
              key={s.site_id}
              style={{ padding: '8px 10px', cursor: 'pointer', borderBottom: '1px solid var(--border)' }}
              onMouseDown={() => {
                onChange(s.site_id);
                setOpen(false);
              }}
            >
              <div style={{ fontWeight: 600 }}>{label(s)}</div>
              {s.city && (
                <div className="muted" style={{ fontSize: 12 }}>
                  {s.city}, {s.state}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
